export default function without(arr = [], ...args) {
  return arr.filter((item) => !args.includes(item));
}
